<template>
  <div id="app">
    <header>
      <router-link to="/" class="logo"
        ><img alt="Monad Logo" src="@/assets/logo.png"
      /></router-link>
      <Nav />
      <User />
    </header>
    <main>
      <div class="content">
        <router-view />
      </div>
      <Messages />
    </main>
  </div>
</template>

<script>
import Messages from "@/components/Messages.vue";
import Nav from "@/components/Nav.vue";
import User from "@/components/User.vue";
import "vue-good-table/dist/vue-good-table.css";
require("@/assets/app.css");

export default {
  components: { Messages, Nav, User }
};
</script>
